import { FormControl, FormLabel, useColorModeValue as mode } from '@chakra-ui/react';
import { useModule } from '@starberry/components';
import React from 'react';

const FormSelectField = ({
  values,
  defaultValue,
  id,
  onBlur,
  onChange,
  placeholder,
  name,
  label,
  type,
  variant,
  displayEmpty,
  value,
  error,
  ...props
}) => {
  const Select = useModule('Select');
  if (!Select) {
    return null;
  }
  
  return (
    <FormControl position="relative" isInvalid={error !== undefined}>
      {label && (
        <FormLabel
          _focus={{ color: mode('blue.600', 'blue.300') }}
          position="absolute"
          fontSize={14}
          fontWeight="normal"
          color={mode('gray.500', 'white')}
          top="-3"
          insetStart="2"
          bg={{ base: mode('white', 'gray.800'), md: mode('white', 'gray.700') }}
          zIndex={1}
          px="2"
        >
          {label}
          {props.required && ' *'}
        </FormLabel>
      )}
      <Select
        defaultValue={defaultValue}
        value={value}
        placeholder={placeholder}
        name={name}
        label={label}
        variant={variant}
        displayEmpty={displayEmpty}
        type={type}
        options={values}
        onChange={() => (e) => {
          onChange?.(e.value);
        }}
      />
    </FormControl>
  );
};
export default FormSelectField;
